export default "__VITE_ASSET__DBPA9CW0__"